module.exports = __webpack_public_path__ + "img/芒果11.7edf06aa.png";